import DateRangePickerController from './date-range-picker.controller';
import { DateRangePickerProps } from './date-range-picker.model';

const DateRangePicker = (props: DateRangePickerProps) => {
  return <DateRangePickerController {...props} />;
};

export default DateRangePicker;
